module.exports = __webpack_public_path__ + "static/media/faq-download-app.8aa94672.svg";